import { render, staticRenderFns } from "./filePreview.vue?vue&type=template&id=e9a6ec86&scoped=true&"
import script from "./filePreview.vue?vue&type=script&setup=true&lang=js&"
export * from "./filePreview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./filePreview.vue?vue&type=style&index=0&id=e9a6ec86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a6ec86",
  null
  
)

export default component.exports